// extracted by mini-css-extract-plugin
export default {"presets":"theme_presets__cibmr"};